import { redirectToLogout } from "src/redux/actions/application";
import { store } from "src/App";
import { getUserInfo } from "src/common/userInfo";

/**
 * Wrapper for handling fetch errors since fetch won't handle it natively
 */
export const handleErrors = (response) => {
  if (response.status === 421) {
    response.json().then((res) => {
      if (res.redirectUrl) {
        window.location.href = res.redirectUrl;
      }
    }).catch((err) => {
      console.error("Failed to parse 421 response:", err);
    });
    return response;
  }
  // If the status is a 401, our token in no longer valid and the user needs to log back in.
  if (response.status === 401 && store) {
    store.dispatch(redirectToLogout());
  }
  if (!response.ok || response.status > 206) {
    if (response?.json) {
      return response.json().then((res) => {
        const error = new Error(res.message);
        error.code = response.status;
        error.message = res.message;
        throw error;
      });
    }
    throw new Error();
  }
  return response;
};

// Code used to fake a click to download csv
export function saveFileFromBlobData(data, fileName) {
  const a = document.createElement("a");
  document.body.appendChild(a);
  a.setAttribute("style", "display: none;");
  const blob = new Blob([data], { type: "octet/stream" }),
    url = window.URL.createObjectURL(blob);
  a.href = url;
  a.download = fileName;
  a.click();
  window.URL.revokeObjectURL(url);
  a.remove();
}

const dataToCsvURI = (data) =>
  encodeURI(
    `data:text/csv;charset=utf-8,${data.map((row) => row.join(",")).join(`\n`)}`,
  );

export const convertDataToCSVDownload = (
  rows = [],
  filename = "example.csv",
) => {
  const csvEl = document.createElement("a");
  const url = dataToCsvURI(rows);
  csvEl.href = url;
  csvEl.setAttribute("download", filename);
  csvEl.click();
  csvEl.remove();
};

const mockDebtors = new Set([
  "0000000TES",
  "0000CANADA",
  "00CSMEDEMO",
  "00NZGLOBAL",
  "0AUSGLOBAL",
  "APEXGLOBAL",
  "ASIAGLOBAL",
  "DELOITDEMO",
  "EMEAGLOBAL",
  "PLAYWRIGHT",
  "SBT000DEMO",
  "USA1234567",
  "USLIGHTZZZ",
  "ZILLOWDEMO",
]);

export const shouldMockData = () => {
  const user = getUserInfo();
  if (!user) return false;

  try {
    const debtorId = user["https://www.ctmsmart.com/debtor"];
    return mockDebtors.has(debtorId);
  } catch {
    return false;
  }
};
